import { Box } from "@mui/system"
import {
    Card,
    CardContent,
    Stack,
    Typography
} from "@mui/material"
import CalendarMonthTwoToneIcon from '@mui/icons-material/CalendarMonthTwoTone';
import { dateSymbols } from "../../dateSymbols";


export const ReleaseDates = (props) => {
    const { dates } = props

    return (
        <Card>
            <CardContent>
                <Stack direction='row' spacing={1} alignItems='center'>
                    <CalendarMonthTwoToneIcon sx={{ fontSize: 40 }} color='primary' />
                    <Typography variant='h5' color='secondary'>
                        Release Dates
                    </Typography>
                    <Typography sx={{ color: 'gray' }}>(Warehouse P/U)</Typography>
                </Stack>

                <Stack spacing={4} sx={{ mt: 4 }}>
                    {dates && dates.map((item, idx) => {
                        const date = Object.values(item)[0]

                        if (date === '') return null
                        
                        return (
                            <Box key={idx} sx={{
                                p: 2,
                                border: '1px solid lightgray'
                            }}>
                                <Stack direction='row' spacing={4} alignItems='center'>
                                    {dateSymbols[idx]}
                                    <Typography variant='h5'>{date}</Typography>
                                </Stack>
                            </Box>
                        )})
                    }
                </Stack>

            </CardContent>
        </Card>
    )
}